<template>
    <RouterView v-slot="{ Component }">
        <MagTransition name="fade" mode="out-in">
            <template v-if="Component">
                <Suspense :suspensible="nested" timeout="200">
                    <component
                        :is="Component"
                        :key="accountStore.currentUserId ?? '@local'"
                    />
                    <template #fallback>
                        <MkLoading />
                    </template>
                </Suspense>
            </template>
        </MagTransition>
    </RouterView>
</template>

<script setup lang="ts">
import { useAccountStore } from "@/model/account";

const accountStore = useAccountStore();

withDefaults(
    defineProps<{
        nested?: boolean;
    }>(),
    {
        nested: false,
    },
);
</script>
